import Vue from 'vue'

const TAG_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};

const TAG_SET_TAGCATEGORIES =(state, payload)=> {
            
    state.data.tagcategory_ids = payload
};


const TAG_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};


const TAG_SET_TAGS =(state, payload)=> {  
    
    state.tags=payload
    
};

const TAG_SET_TAG =(state, payload)=> {       
    
    state.data.name = payload.name
    
    state.data.tagcategory_ids = payload.tagcategories.map(t=>t.tagcategory_id)
};

const TAG_INIT_TAG =(state, payload)=> {       
    state.data.name = ''    
    state.data.tagcategory_ids=[]
};



export default {
    TAG_SET_NAME,
    TAG_SET_TAGCATEGORIES,
    TAG_SET_DUPLICATE,
    TAG_SET_TAGS,
    TAG_SET_TAG,
    TAG_INIT_TAG,
};